export const DATAGRID_INITIAL_PAGE_SIZE = 25;
export const DATAGRID_PAGE_SIZE_OPTIONS = [10, 25, 50, 100];
export const DATAGRID_INITIAL_PAGE = 0;
